import { SAMPLE_RATES } from '../constants'

export const SAMPLE_SMALL_AMOUNT = Math.random() < SAMPLE_RATES.SMALL_SAMPLE_RATE
export const SAMPLE_MEDIUM_AMOUNT = Math.random() < SAMPLE_RATES.MEDIUM_SAMPLE_RATE
